import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './KeyboardShortcutsModal.css';

const SHORTCUTS = [
  { label: 'Play/Pause', key: 'Space' },
  { label: 'Delete', key: 'Delete' },
  { label: 'Undo', key: 'Ctrl+Z' },
  { label: 'Redo', key: 'Ctrl+Y' },
  { label: 'Copy', key: 'Ctrl+C' },
  { label: 'Paste', key: 'Ctrl+V' },
  { label: 'Move Clip', key: 'Drag Clip' },
  { label: 'Trim Clip', key: 'Drag Clip Edges' }
];

const KeyboardShortcutsModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div 
      role="button"
      tabIndex={0}
      className="keyboard-shortcuts-overlay"
      onClick={onClose}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClose();
        }
      }}
    >
      <div 
        role="dialog"
        aria-modal="true"
        className="keyboard-shortcuts-modal"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <div className="keyboard-shortcuts-header">
          <h2 className="keyboard-shortcuts-title">Keyboard Shortcuts</h2>
          <button onClick={onClose} className="keyboard-shortcuts-close">
            ×
          </button>
        </div>
        
        <div className="keyboard-shortcuts-grid">
          {SHORTCUTS.map((shortcut) => (
            <div key={shortcut.key} className="keyboard-shortcut-item">
              <span>{shortcut.label}</span>
              <kbd className="keyboard-shortcut-key">{shortcut.key}</kbd>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

KeyboardShortcutsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default KeyboardShortcutsModal;
